import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { StationService } from '@accounts/user/services/station.service';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material';
import { ModalRentalPanelComponent } from '@accounts/user/components/modal-rental-panel/modal-rental-panel.component';
import { Subscription } from 'rxjs';
import { BottomPopupComponent } from '@ui/bottom-popup/bottom-popup.component';
import { BottomPopupService } from '@ui/bottom-popup/bottom-popup.service';
import { TrailerListComponent } from '@accounts/user/components/trailer-list/trailer-list.component';
import { FinishRentComponent } from '@accounts/user/components/finish-rent/finish-rent.component';
import { OrderService } from '@accounts/user/services/order.service';
import { InRentTrailerService } from '@accounts/user/services/in-rent-trailer.service';
import { HttpParams } from '@angular/common/http';
import { OrderModel } from '@core/api';
import { UserService } from '@accounts/user/services/user.service';

@Component({
  selector: 'user-new-pick-trailer-map',
  templateUrl: './user-new-pick-trailer-map.component.html',
  styleUrls: ['./user-new-pick-trailer-map.component.scss']
})
export class UserNewPickTrailerMapComponent implements OnInit, OnDestroy {

  init: boolean = false;
  loading: boolean = false;
  rentalPanel: MatSnackBarRef<ModalRentalPanelComponent>;
  inRentOrders$: Subscription;
  stationLoadingSubscription: Subscription;

  constructor(
    public stationService: StationService,
    private bottomPopup: BottomPopupService,
    private snackBar: MatSnackBar,
    private orderService: OrderService,
    private userService: UserService,
    private inRentTrailerService: InRentTrailerService,
  ) {
      this.stationLoadingSubscription = this.stationService.stationLoading$.subscribe(loading => {
          this.loading = loading;
          if(!loading && stationService.station){
              const config={headerText: this.stationService.station.name}
              this.bottomPopup.open(TrailerListComponent, config);
          }
      });

    if(!!userService.user && userService.user.role === 'user'){
    this.inRentOrderMessage();

    const params = new HttpParams();
    this.inRentOrders$ = orderService.getInrentOrders(params)
      .subscribe(data => {
        if (!!data && data.length > 0) {
          this.openRentalPanel(data[0]);
        }
        else {
          this.closeRentalPanel();
        }
      });
    }
  }

    inRentOrderMessage() {
        const httpParams = new HttpParams();
        this.orderService.getOrders(httpParams).subscribe(
            orders => {
                if (!!orders) {
                    const inRentOrders = orders.data.filter(x => x.status === OrderModel.StatusEnum.InRent);
                    const closedOrders = orders.data.filter(x => x.status === OrderModel.StatusEnum.Closed)
                    const inRentDataFromStorage = this.inRentTrailerService.value;

                    //show the finish rent message if the user  has a 'IN_RENT_TRAILER' in the local storage and the same trailer ID and order ID are in his closed orders
                    if (!!inRentDataFromStorage && closedOrders.some(closeOrder => closeOrder.trailer_id === inRentDataFromStorage.trailer_id && closeOrder.id === inRentDataFromStorage.order_id)) {
                        this.showFinishRentMessage();
                        this.inRentTrailerService.reset();
                    }

                    //save in rent order data to the storage
                    if (!!inRentOrders && inRentOrders.length > 0) {
                        const trailerId = inRentOrders[0].trailer_id;
                        const orderId = inRentOrders[0].id;
                        if (!!trailerId && !!orderId) {
                            this.inRentTrailerService.save({
                                order_id: orderId,
                                trailer_id: trailerId
                            });
                        }

                    }

                }
            }
        )
    }

    showFinishRentMessage() {
        const config = { headerText: "" }
        this.bottomPopup.open(FinishRentComponent, config);
    }

  ngOnInit() {
    this.init = true;
  }

  closeRentalPanel() {
    if (!!this.rentalPanel) {
      this.rentalPanel.dismiss();
    }
  }

  openRentalPanel(order: OrderModel) {
    const config: MatSnackBarConfig = {
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: 'rental-panel-base',
      data: { order }
    };
    this.rentalPanel = this.snackBar.openFromComponent(ModalRentalPanelComponent, config);
  }

  ngOnDestroy(): void {
    this.stationLoadingSubscription.unsubscribe();

    if(!!this.inRentOrders$){
      this.inRentOrders$.unsubscribe();
    }

    this.closeRentalPanel();
  }

}
